// extracted by mini-css-extract-plugin
export default {"wrapper":"A4-z","play":"B4-z"};